module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"passReset":"Восстановление пароля","email":"E-mail","sendEmail":"Сменить пароль","registration":"Регистрация","login":"Вход","recoveryInfoSent":"Информация для восстановления отправлена на электронную почту."}}')
  delete Component.options._Ctor
}
